import { useTranslation } from 'react-i18next';
import { AssetDetailsLinkList } from 'src/components/assets/AssetDetailsLinkList';
import { SiteHeader } from 'src/components/ui/SiteHeader';
import { TAssetStage } from '@brickwise/asset-validation/dist/schema/enums';
import { Routes } from 'src/router/Routes';
import { isNullUndefinedOrEmpty } from 'src/util/utils';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import { PreordersTable } from '../../components/assets/asset-preorder/PreordersTable';
import { useAsset } from '../../context-providers/AssetContext';

export const AssetPreorder = () => {
  const { t } = useTranslation();
  const { asset } = useAsset();
  const loading = false;

  return (
    <>
      <SiteHeader
        breadcrumbs={[
          {
            link: Routes.ASSETS.ROOT,
            label: t('dashboard.breadcrumbs.assets'),
            icon: <ApartmentOutlinedIcon sx={{ mr: 0.5 }} fontSize="inherit" />,
          },
          {
            link: Routes.ASSETS.EDIT.replace(':assetId', asset?.id ?? ''),
            label: (isNullUndefinedOrEmpty(asset?.descriptions?.title) ? asset?.id : asset?.descriptions?.title) ?? '',
          },
          {
            link: Routes.ASSETS.PREORDER.replace(':assetId', asset?.id ?? ''),
            label: t('dashboard.breadcrumbs.preorders'),
          },
        ]}
        headline={asset ? (isNullUndefinedOrEmpty(asset.descriptions?.title) ? asset.id : (asset.descriptions.title as string)) : ''}
      >
        {asset && (
          <AssetDetailsLinkList
            assetId={asset.id}
            useSerialNumber={asset.useSerialNumber}
            active={'preorder'}
            isPrimary={asset?.investmentDetails.stage === TAssetStage.primary}
            isSecondary={asset?.investmentDetails.stage === TAssetStage.secondary}
            isPreorder={asset?.investmentDetails.stage === TAssetStage.preorder}
            securityType={asset?.investmentDetails?.securityType}
          />
        )}
      </SiteHeader>
      {!loading && (
        <>
          <PreordersTable assetId={asset.id} />
        </>
      )}
    </>
  );
};
